import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANIES = "fetchCompanies";

// mutation types
export const SET_COMPANIES = "setCompanies";
export const SET_COMPANIES_PAGINATION = "setCompaniesPagination";
export const SET_ADMIN_COMPANY_PRICES = "setCompaniesPagination";

const state = {
  companies: [],
  companiesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  companies(state) {
    return state.companies;
  },
  companiesPagination(state) {
    return state.companiesPagination;
  }
};

const actions = {
  [FETCH_COMPANIES](context, name = null) {
    let params = {
      page: context.state.companiesPagination.currentPage
    };
    if (name) {
      params.name = name;
    }
    return new Promise((resolve, reject) => {
      ApiService.query("admin/companies", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANIES, data.data);
          context.commit(SET_COMPANIES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANIES](state, companies) {
    state.companies = companies;
  },
  [SET_COMPANIES_PAGINATION](state, data) {
    state.companiesPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
